/**axios封装
 * 请求拦截、响应拦截
 */
import Vue from "vue"
import axios from 'axios'
import qs from 'qs'
import toast from 'common/js/toastification'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

Vue.use(Loading)

/****** 创建 axios 实例 ******/
const service = axios.create({
  baseURL: "/",  // 配置接口默认地址
  withCredentials: true,  // 允许跨域带token
  timeout: 30000  // 请求超时时间
})

let timer = 0

// http request 拦截器，目的是为了在请求头上带上token
service.interceptors.request.use(
  config => {
    // 请求时间超过2秒后才显示加载中的样式
    if (timer === 2) {
      timer = setTimeout(() => {
        Vue.$loading.show({
          color: '#3381ff',
          loader: 'bars',
          width: 40,
          height: 40
        })
      }, 2000)
    }

    if (config.method === 'get') {
      // 如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2，不转换则会显示为arr[]=1&arr[]=2
      config.params = {...config.params}
      config.paramsSerializer = function (params) {
        return qs.stringify(params, {indices: false})
      }
    } else if (config.method === 'post') {
      config.data = qs.stringify({...config.data})
    }

    /*config.method === 'post'
      ? config.data = qs.stringify({...config.data})
      : config.params = {...config.params}*/
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'

    let pathname = location.pathname
    let token = localStorage.getItem('token')

    if (token) {
      if (pathname !== '/' && pathname !== '/index') {
        // token字段是要和后端协商好的
        config.headers.common["token"] = token
      }
    }
    return config
  },
  error => {
    if (timer !== 0) {
      clearTimeout(timer) // 清除定时器
      timer = 0
      $(".vld-overlay").hide() // 关闭加载中的遮罩层
    }
    alert('请求超时，请稍后重试！')
    return Promise.reject(error)
  })

// http response 拦截器
service.interceptors.response.use(
  response => {  // 成功请求到数据
    if (timer !== 0) {
      clearTimeout(timer) // 清除定时器
      timer = 0
      $(".vld-overlay").hide() // 关闭加载中的遮罩层
    }
    // 这里根据后端提供的数据进行对应的处理
    if (response.data && response.data.code) {
      let data = response.data
      let code = data.code

      switch (code) {
        // -2是未登录的状态码，本地存储清除token、用户信息、当前页面id及库权限，并跳转到登录页面
        case -2:
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          sessionStorage.removeItem('folderPath')
          sessionStorage.removeItem('libId')
          Vue.$toast.warning(data.data, {
            timeout: 2000,
            hideProgressBar: true
          })
          setTimeout(() => {
            location.href = 'index.html'
          }, 2000)
          break
        // -3是没有操作权限的状态码
        case -3:
          Vue.$toast.warning(data.data, {
            timeout: 2000,
            hideProgressBar: true
          })
          break
        default:
          Vue.$toast.error("系统错误", {
            timeout: 2000,
            hideProgressBar: true
          })
      }
    }
    return response
  },
  error => {  // 响应错误处理
    if (timer !== 0) {
      clearTimeout(timer) // 清除定时器
      timer = 0
      $(".vld-overlay").hide() // 关闭加载中的遮罩层
    }
    alert('请求失败，请稍后重试！')
    // 返回接口返回的错误信息
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/common/js/service.js